import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CrudBaseService } from '../crud.service';
import { Promotion, PromotionFilterBody } from '../models/promotion';
import { HttpHelper } from '../../helpers/http.helper';

import { map } from 'rxjs/operators';

@Injectable()
export class PromotionService extends CrudBaseService<Promotion> {
    constructor(httpClient: HttpClient) {
        super('/promotion', httpClient);
    }

    listPromotions(filterParams: any, body: PromotionFilterBody) {
        body.is_admin_page = true;
        return this.httpClient
            .post(
                `${this.basePath}/list`,
                {
                    data: body
                },
                { params: HttpHelper.objectToHttpParams({ ...filterParams }) }
            )
            .pipe(map((res: any) => res && res.data));
    }
}
